// import * as am4charts from "@amcharts/amcharts4/charts";
// import {am4Settings} from "@/mixins/am4charts/am4Settings";

/*
 * Definition for a series Interval to load
 * start: Date
 * end: Date
 * useUTC: boolean
 * requestNumber: integer
 */

import axios from 'axios'
import * as _ from "lodash"
import {am4Settings} from "@/mixins/am4charts/am4Settings";
import _isNil from "lodash";

const REPLACE = 0
const PREPEND = 1
const APPEND = 2

const LOADING_STATUS = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
}

export const SeriesDataLoader = class {
    constructor(series) {
        this.create(series)
    }

    addInterval(start, end, addMode = REPLACE, useUTC = false) {
        // Add requested interval
        this.intervalsToLoad.push({
            start: _.clone(start),
            end: _.clone(end),
            append: false,
            addMode: addMode,
            useUTC: useUTC,
            isLoading: LOADING_STATUS.NOT_STARTED,
        })

        // If we are currently showing the series and the data loader isn't already running, load the data
        if (this.series.isVisible() && ! this.running) {
            this.start()
        }
    }

    loadData(interval) {
        let start = _.isNil(interval.start) ? this.series.start : interval.start
        let end = _.isNil(interval.end) ? this.series.end : interval.end

        // Set the series loading status to completed
        this.intervalsToLoad[0].isLoading = LOADING_STATUS.IN_PROGRESS

        console.time(`Load Series Data: ${this.series.id} - ${start.toISOString()} - ${end.toISOString()}`)
        let data = []
        axios.get(`/api-internal/${this.series.company}/data-meter/${this.series.id}`, {
            params: {
                startDate: start.toISOString(),
                endDate: end.toISOString(),
                requestNumber: this.requestNumber,
                useUTC: interval.useUTC,
            }
        }).then(response => {
            console.timeLog(`Load Series Data: ${this.series.id}`, 'First Response')

            let responseData = response.data
            if (responseData.requestNumber != this.requestNumber) {
                console.log(`Request Number Mismatch: Response: ${responseData.requestNumber} !== Request: ${this.requestNumber}`)
                return
            }

            this.requestNumber++
            data = responseData.data

            this.series.setPointData(data, interval.addMode)
        }).catch(error => {
        }).then(() => {
            if (!_.isNil(this.series.sideAxis)) {
                this.series.sideAxis.updateMinMax()
            }
            else {
            }

            if (!_.isNil(am4Settings.updateVueHook)) {
                am4Settings.updateVueHook()
            }
            console.timeEnd(`Load Series Data: ${this.series.id}`, 'First Response')

            // Set the series loading status to completed
            this.intervalsToLoad[0].isLoading = LOADING_STATUS.COMPLETED
        })
    }

    logLoadedInterval(start, end) {
        this.loadedIntervals.push({
            start: start,
            end: end,
        })
    }

    async startLooping() {
        while (this.running) {
            // If there are no more intervals to load, stop the loop
            if (this.intervalsToLoad.length === 0) {
                // Since we are done loading intervals, we should trigger the Vue update hook to ensure the
                //   Loading Graph Data Spinner is removed
                if (!_.isNil(am4Settings.updateVueHook)) {
                    am4Settings.updateVueHook()
                }
                this.stop()
                continue
            }

            this.run()
            await this.sleep(200)
        }
    }

    run() {
        let interval = this.intervalsToLoad[0]
        if (_.isNil(interval)) {
            this.intervalsToLoad.shift()
            return
        }

        // Determine if the interval is loading already and return if it is
        if (interval.isLoading === LOADING_STATUS.IN_PROGRESS) {
            return
        }

        // Determine if the next interval is finished loading
        if (interval.isLoading === LOADING_STATUS.COMPLETED) {
            // Remove the interval from the list
            this.intervalsToLoad.shift()
            return
        }

        // If the interval needs to be loaded, load it
        if (interval.isLoading === LOADING_STATUS.NOT_STARTED) {
            this.intervalsToLoad[0].isLoading = LOADING_STATUS.IN_PROGRESS
            this.loadData(interval)
        }
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    start() {
        this.running = true
        this.startLooping().then()
    }

    stop() {
        this.running = false
    }

    reset() {
        this.intervalsToLoad = []
        this.loadedIntervals = []
        this.requestNumber = 0
        this.running = false
    }

    clear() {
        this.intervalsToLoad = []
        this.loadedIntervals = []
        this.requestNumber = 0
    }

    clearQueue() {
        this.intervalsToLoad = []
    }

    create(series) {
        this.series = series
        this.reset()
    }
}
